import React from 'react';
import { inject, observer } from 'mobx-react';

import {
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardBlock,
  CardTitle,
  CardText,
  Button
} from 'reactstrap';

import Player from 'react-player';

import FilmData from './FilmData.js';

@inject('appState')
@observer
class Films extends React.Component {
  constructor() {
    super();
    this.state = { url: '', playing: false };
  }
  clickThumb(vid, groupName) {
    if (vid.url.includes('youtube') || vid.url.includes('vimeo')) {
      window.scrollTo(0, 0);
      this.setState({
        url: vid.url,
        groupName: groupName,
        title: vid.title,
        type: vid.type,
        text: vid.text,
        playing: true
      });
    } else {
      window.open(vid.url);
    }
    
  }
  filterFilms(name) {}
  render() {
    const { films, filmGroupNameFilter } = this.props.appState;
    return (
      <Container fluid className="py-5 mt-5">
        {this.state.playing && this.state.type !== 'iframe'
          ? <div className="pb-4">
              <Player
                url={this.state.url}
                playing={this.state.playing}
                controls={true}
                width={'100%'}
                height={'70vh'}
                className="mb-4"
              />
              <h2>
                {this.state.groupName === 'Bumbloods'
                  ? `Bumbloods - ${this.state.title}`
                  : this.state.title}
              </h2>
              <CardText
                style={{ color: 'rgba(255,255,255,.65)' }}
                dangerouslySetInnerHTML={{ __html: this.state.text }}
              />
            </div>
          : ''}
        {this.state.playing && this.state.type === 'iframe'
          ? <div className="pb-4">
              <iframe
                id="ls_embed_1493572214"
                src={this.state.url}
                width="100%"
                height="500"
                frameborder="0"
                scrolling="no"
                allowfullscreen
              >
                {' '}
              </iframe>
              <h2>{this.state.title}</h2>
              <CardText
                style={{ color: 'rgba(255,255,255,.65)' }}
                dangerouslySetInnerHTML={{ __html: this.state.text }}
              />
            </div>
          : ''}
        <Container className="p-2 my-2 groupFilter d-flex align-items-center justify-content-center justify-content-lg-between flex-wrap">
          <Button
            size="md"
            color="secondary"
            outline={filmGroupNameFilter !== 'all'}
            onClick={() => this.props.appState.setFilmGroupNameFilter('all')}
            className="mx-2 mb-2"
          >
            All Work
          </Button>
          {FilmData.films.map(filmGroup => (
            <Button
              size="md"
              color="secondary"
              outline={filmGroupNameFilter !== filmGroup.name}
              className="mx-2 mb-2"
              key={`filterGroup${filmGroup.name}`}
              onClick={() =>
                this.props.appState.setFilmGroupNameFilter(filmGroup.name)}
            >
              {filmGroup.name}
            </Button>
          ))}
        </Container>
        {films.map(filmGroup => (
          <Row className="py-3" key={`filmGroup${filmGroup.name}`}>
            <Col xs="12">
              <h3>
                {filmGroup.name}
                {' '}
                <small className="text-muted">{filmGroup.subtitle}</small>
              </h3>
            </Col>
            {filmGroup.vids.map(vid => (
              <Col
                xs="12"
                md="6"
                lg={filmGroup.vids.length <= 2 ? '6' : '4'}
                key={`film${vid.title}`}
              >
                <Card inverse className="my-2 border-0">
                  <div className="filmImg" onClick={() => this.clickThumb(vid, filmGroup.name)}>
                    <div className="overlay d-flex justify-content-center align-items-center">
                      <i className="fa fa-play fa-3x" />
                    </div>
                    <CardImg top width="100%" src={vid.image} />
                  </div>
                  <CardBlock className="px-0">
                    <CardTitle>{vid.title}</CardTitle>
                    <CardText dangerouslySetInnerHTML={{ __html: vid.text }} />
                  </CardBlock>
                </Card>
              </Col>
            ))}
          </Row>
        ))}
      </Container>
    );
  }
}

export default Films;



// WEBPACK FOOTER //
// ./src/Videos.js